import React, { Component } from "react";
import {
  ComponentBox,
  DataView,
  DataWrapperClass,
  DateView,
  UserName,
  ContentData,
  BoxData,
  IconData,
  TagLine,
  DescData,
  DataViewList,
  EditorCSS,
  InsightRow,
  Header,
} from "../styles/main";
import { Col, Row, Tab, Tabs } from "react-bootstrap";
import {
  DataWithLoader,
  FormWrapper,
  FormColumn,
  FormGroup,
  ControlLabel,
  FormControl,
  SeachForm,
  Alert,
  ButtonCommonTheme,
} from "modules/theme";
import Select from "react-select-plus";
import styled from "styled-components";
import { Editor } from "react-draft-wysiwyg";
import APIManager from "modules/common/apiManager";
import {
  convertToRaw,
  EditorState,
  ContentState,
  Modifier,
  convertFromHTML,
} from "draft-js";
import draftToHtmlPuri from "draftjs-to-html";
import { PerPage } from "helpers/system-config";
import htmlToDraft from "html-to-draftjs";
import { connect } from "react-redux";
import {
  chatSelector,
  globalStateSelector,
  smsemailSelector,
} from "../../../../../store/selector";
import {
  callAction,
  chatAction,
  smsemailAction,
} from "../../../../../store/action";
import { Spinner } from "modules/common/components";
import { smsCounter } from "../../../../common/utils";
import MessageScreenBody from "../../../../screens/chatscreen/components/MessageScreenBody/MessageScreenBody";
import { RenderInitials } from "../../../../screens/chatscreen/components/Avatar";
import {
  getName,
  getNameCall,
  getPlatform,
} from "../../../../screens/chatscreen/components/utils/generic";

import "./ContactInfoActivityTimelineTheme.css";
import { FaWandMagicSparkles } from "react-icons/fa6";
// import Editor from './Editor';
const CharacterCounts = styled.div`
  display: flex;
  justify-content: flex-end;
  .dark-text {
    font-weight: 500;
    margin-right: 5px;
  }
`;
const SMForm = styled.div`
  display: flex;
  flex-wrap: wrap;
  .sc-igwadP.cibmtx {
    width: 90%;
  }
  // flex-direction:row;
  // align-items:stretch;
`;
const Button = styled.button`
  background: ${(props) => (props.bgColor === "blue" ? "#28a6de" : "#ff0d0d")};
  border: none;
  color: #fff;
  font-family: "Poppins";
  padding: 6px 22px;
  font-weight: 600;
  margin-bottom: 8px;
  font-size: 15px;
  border-radius: 6px;
`;
const TextArea = styled.textarea`
  height: 100px;
  width: 100%;
`;
const GreyText = styled.div`
  height: 21px;
  display: flex;
  align-items: center;
  padding: 10px;
  border-radius: 5px;
  cursor: pointer;
  background: ${(props) => (props.isSelected ? "#e0e0e0" : "")};
  &:hover {
    background: #e0e0e0;
  }
`;
const ResetCss = styled.div`
  img {
    height: auto;
    width: auto;
    border-radius: 0px;
  }
  // .public-DraftStyleDefault-ltr {
  //   direction: ltr;
  //   /* border: 2px solid black; */
  //   text-align: left;
  //   background: #FFFFFF;
  //   box-shadow: 0px 3px 20px rgb(0 0 0 / 10%);
  //   border-radius: 10px;
  //   height: 100px;
  //   width: 90%;
  //   margin: 15px auto;
  //   padding: 5px;
  // }
  .rdw-editor-toolbar {
    margin-bottom: 0px;
  }
  .DraftEditor-root {
    overflow: hidden;
    word-break: break-all;
    z-index: 0;
    direction: ltr;
    text-align: left;
    background: #ffffff;
    /* box-shadow: 0px 3px 20px rgb(0 0 0 / 10%); */
    /* border-radius: 10px; */
    height: 130px;
    overflow: auto;
    border: 1px solid #f1f1f1;
    /* width: 95%; */
    border-top: none;
    min-height: 113px;
    margin: 0px;
    padding: 5px;
  }
`;
const Label = styled.label`
  -webkit-transition: all 0.3s;
  -moz-transition: all 0.3s;
  -ms-transition: all 0.3s;
  -ms-transition: all 0.3s;
  transition: all 0.3s;
  backface-visibility: hidden;
  -webkit-backface-visibility: hidden; /* Chrome and Safari */
  -moz-backface-visibility: hidden; /* Firefox */
  -ms-backface-visibility: hidden; /* Internet Explorer */
  width: 100%;
  padding: 12px;
  font-size: 16px;
  font-weight: 400;
  cursor: pointer;
  &:hover {
    background: #ececec;
  }
`;

const TabItemsStyle = styled.div`
  height: 100%;
  width: 100%;
  .tabItemStyle {
    display: flex;
    // align-items: flex-end;
    // height: 52px;
    // padding: 0px 20px;
    // border-bottom: 1px solid rgb(226, 232, 239);
  }

  .tab-content,
  .tab-pane {
    height: 100%;
  }

  .tabItemStyle > div {
    width: 100%;
    // height: calc(100% - 8px);
    // display: flex;
    // -webkit-box-align: center;
    // align-items: center;
    // position: relative;
    // flex-flow: row-reverse wrap;
    // -webkit-box-pack: start;
    // justify-content: flex-start;
  }

  .tabItemStyle > div > ul {
    display: flex;
    flex-direction: row;
    -webkit-box-pack: start;
    justify-content: flex-start;
    -webkit-box-align: center;
    align-items: center;
    flex: 1 1 0%;
    border: none;
    border-bottom: 1px solid rgb(226, 232, 239);
    padding: 30px 20px 0px 20px;
  }

  ul > li > a {
    position: relative;
    padding: 3px 8px 12px;
    font-size: 14px;
    cursor: pointer;
    color: rgb(100, 116, 145);
    border: none !important;
    font-weight: 600;
    background: #fff;
    // border-bottom: 3px solid #fff !important;
  }

  ul > li.active > a,
  ul > li.active > a:focus,
  ul > li.active > a:hover {
    color: rgb(8, 15, 26) !important;
    border-bottom: 3px solid rgb(5, 102, 255) !important;
    background: #fff !important;
    font-weight: 600 !important;
  }

  li > a:hover {
    background: #fff !important;
  }
  // ul > li > a:hover {
  //   color: rgb(8, 15, 26);
  //   border-bottom: 1px solid rgb(5, 102, 255);
  // }
`;

const EmptyStateStyled = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  flex: 1;
  justify-content: center;
  text-align: center;
  font-size: 14px;
  padding: 70px;
  color: #888;
  gap: 10px;

  img {
    max-height: 260px;
    width: auto;
    margin: auto;
  }
`;

export class ContactInfoSmartAgent extends Component {
  constructor(props) {
    super(props);
    this.textAreaRef = React.createRef();
    this.mAPI = new APIManager();
    this.saveData = this.saveData.bind(this);
    this.textAreaStyle = {
      height: "180px",
      width: "100%",
      padding: "15px",
      outline: "none",
    };
    this.state = {
      isActive: false,
      valueForBcc: [],
      valueForCC: [],
      valueForTo: [],
      defaultcc: [],
      defaultBcc: [],
      defaultTo: [],
      loading: false,
      listData: [],
      listDataSMS: [],
      total: 0,
      currentPage: 1,
      perPageCount: PerPage,
      showCC: false,
      showBcc: false,
      smsTemplateValue: "",
      oldSMSTemplateValue: "",
      oldEmailTemplateValue: "",
      templateIdEmail: "",
      templateIdSMS: "",
      smsButtons: [],
      showAvailabeEmailTemplates: false,
      showAvailabeSMSTemplates: false,
      emailButtons: [],
      smsResults: [],
      emailResults: [],
      loadingSendButton: {
        sms: false,
        email: false,
      },
      scrolled: false,
      isLoading: false,
      suggestion: "",
      prompt: "",
      suggestionsList: [],
      showTranscript: false,
      userScrolled: false,
    };
    this.setEmail = this.props.setEmail;
    this.setAgentAssist = this.props.setAgentAssist;
    this.setSms = this.props.setSms;
    this.conversationEndRef = React.createRef();
    this.messageContainerRef = React.createRef();
  }

  componentDidUpdate(prevProps) {
    // Scroll to the bottom only if user hasn't manually scrolled up
    if (this.props.callTranscript !== prevProps.callTranscript) {
      if (!this.state.userScrolled) {
        this.scrollToBottom();
      }
    }
  }

  scrollToBottom = () => {
    const messageContainer = this.messageContainerRef.current;
    if (messageContainer) {
      // Scroll to the bottom
      messageContainer.scrollTop = messageContainer.scrollHeight;
    }
  };

  handleTabClick = () => {
    // Scroll to the top of the page
    window.scrollTo(0, 0);

    // Reset scroll state
    this.setState({ userScrolled: false });
  };

  handleScroll = () => {
    const messageContainer = this.messageContainerRef.current;
    if (messageContainer) {
      const isAtBottom =
        messageContainer.scrollHeight - messageContainer.scrollTop ===
        messageContainer.clientHeight;

      // If user has scrolled up
      if (!isAtBottom) {
        this.setState({ userScrolled: true });
      } else {
        this.setState({ userScrolled: false });
      }
    }
  };

  getTeam(team) {
    if (team._id) {
      return team._id;
    } else if (team.id) {
      return team.id;
    }
  }
  getTranscriptionInfo(team, teamList) {
    let showAgentAssist;
    let teamId = team && this.getTeam(team);
    teamList &&
      teamList.map((e) => {
        if (e._id === teamId) {
          console.log("eData", e);
          if (e.agentAssist === true) {
            showAgentAssist = true;
            if (e.agentAssist) {
              showAgentAssist = true;
            } else {
              showAgentAssist = false;
            }
          }
        }
      });
    return { showAgentAssist };
  }

  renderFormGroup(label, props) {
    return (
      <div
        style={{
          marginTop: "15px",
          padding: "0 7px",
          ...(props.buttonWidth ? { width: props.buttonWidth } : {}),
        }}
      >
        <FormGroup>
          <ControlLabel required={props.required}>{label}</ControlLabel>
          <FormControl {...props} />
        </FormGroup>
      </div>
    );
  }

  componentWillReceiveProps(nextProps, prevState) {
    if (nextProps.comments) {
      let currentComments = JSON.stringify(nextProps.comments);
      let prevComments = JSON.stringify(prevState.comments);
      if (currentComments !== prevComments) {
        let comments = nextProps.comments;
        this.setState({
          list: this.processData(comments),
        });
      }
    }
  }

  apiResponse(errorCode, data) {
    if (errorCode === 201) {
      let message = data && data.message ? data.message : "Successfully Done";
    } else {
      let message =
        data && data.message ? data.message : "Something wrong happened";
      Alert.error(message);
    }
  }

  resetAllData() {
    this.setState({
      prompt: "",
    });
  }
  getConversationId() {
    const answer = this.props.agentAssist.find((item) => item.key === "Answer");

    if (answer && Array.isArray(answer.value)) {
      const conversationData = answer.value.find(
        (val) => val.type === "text" && val.meta && val.meta.conversationId
      );

      return conversationData
        ? conversationData &&
            conversationData.meta &&
            conversationData.meta.conversationId
        : "";
    }

    return "";
  }

  getSessionId() {
    const answer = this.props.agentAssist.find((item) => item.key === "Answer");

    if (answer && Array.isArray(answer.value)) {
      const sessionData = answer.value.find(
        (val) => val.type === "text" && val.meta && val.meta.sessionId
      );

      return sessionData
        ? sessionData && sessionData.meta && sessionData.meta.sessionId
        : "";
    }

    return "";
  }
  saveData(e) {
    e.preventDefault();
    let _this = this;

    this.setState({ isLoading: true });

    if (!this.state.prompt) {
      Alert.error("Enter Data");
    }

    let suggestion = this.state.prompt || "";
    suggestion = suggestion.trim();
    this.setAgentAssist({ key: "Question", value: suggestion });
    // let tData = {
    //   suggestion: suggestion,
    // };
    const conversationId = this.getConversationId();
    const sessionId = this.getSessionId();
    this.mAPI.sendPostAPI(
      `/agent-response`,
      {
        teamId: this.props.callTeam.id,
        prompt: suggestion,
        meta: {
          conversationId: conversationId || "",
          sessionId: sessionId || "",
        },
        slots: (this.props.callInfo && this.props.callInfo.slots) || [],
      },
      (data) => {
        if (data) {
          _this.resetAllData();
          this.state.suggestionsList = data;
          this.setAgentAssist({ key: "Answer", value: data });
          // dispatch(
          //   chatAction.dynamicUpdate({
          //     data: { key: "agentAssist", value: data },
          //   })
          // );
          // Alert.success(`${data.message}`);
        } else {
          Alert.success(`Successfully Added`);
        }
        this.setState({ isLoading: false });
      },

      (errorCode, data) => {
        this.setState({ isLoading: false });
        this.apiResponse(errorCode, data);
      }
    );
  }

  renderSuggestData(message) {
    if (message) {
      console.log("message112233", message);
      this.setState({
        isLoading: true,
      });
      this.mAPI.sendPostAPI(
        `/agent-response`,
        {
          teamId: this.props.callTeam.id,
          prompt: message.trim(),
        },
        (data) => {
          if (data) {
            this.state.suggestionsList = data;
            // Alert.success(`${data.message}`);
          } else {
            Alert.success(`Successfully Added`);
          }
          this.setState({
            isLoading: false,
          });
        },

        (errorCode, data) => {
          this.setState({
            isLoading: false,
          });
          this.apiResponse(errorCode, data);
        }
      );
    }
  }

  render() {
    const {
      team,
      teamList,
      sms,
      email,
      activeTab,
      callTeam,
      callTranscript,
      messageList,
      callTagList,
      agentAssist,
    } = this.props;

    let { showAgentAssist } = this.getTranscriptionInfo(callTeam, teamList);

    return (
      <DataWrapperClass>
        <InsightRow removeMarginZero={true} className="h-100">
          {showAgentAssist ? (
            <div>
              {agentAssist && (
                <ul className="suggestionBox chat-container">
                  {agentAssist.map((item, index) => (
                    <div
                      key={index}
                      className={`chat-row ${
                        item.key === "Question" ? "question" : "answer"
                      }`}
                    >
                      {item.key === "Question" && (
                        <li className="chat-bubble question-bubble" key={index}>
                          {" "}
                          {item.value}
                        </li>
                        // <div className="resQuestion">
                        //   {item.value}
                        // </div>
                      )}
                      {item.key === "Answer" && (
                        <div className="chat-bubble answer-bubble" style={{backgroundColor: '#f3f3f3'}}>
                          {item.value.map((answer, idx) => (
                            // <div key={idx}>
                            <li key={idx}>
                              {" "}
                              {answer.type === "text" && answer.content}
                            </li>
                          ))}
                        </div>
                      )}
                    </div>
                  ))}
                </ul>
              )}
              <form onSubmit={(e) => this.saveData(e)}>
                <FormWrapper>
                  <FormGroup className="w-100">
                    <div
                      className="d-flex align-items-center"
                      style={{ gap: "10px" }}
                    >
                      {/* <button
                                    className="suggession_btn"
                                    type="submit"
                                  >
                                    <FaWandMagicSparkles
                                      style={{
                                        fontSize: "16px",
                                        display: "block",
                                      }}
                                    />
                                  </button> */}
                      <FormControl
                        type="text"
                        placeholder={"Type to search"}
                        onChange={(e) =>
                          this.setState({ prompt: e.target.value })
                        }
                        value={this.state.prompt}
                        // autoFocus
                        // onFocus={(e) => this.moveCursorAtTheEnd(e)}
                      />

                      <ButtonCommonTheme
                        type="blueModalBtn"
                        btnType="submit"
                        btnStyle="default"
                        className=""
                        size="small"
                        isLoading={this.state.isLoading}
                      >
                        <FaWandMagicSparkles
                          style={{
                            fontSize: "16px",
                            display: "block",
                          }}
                        />
                      </ButtonCommonTheme>

                      {/* <button
                                    className="suggession_btn"
                                    disabled={
                                      !this.state.prompt.trim() ||
                                      this.state.isLoading
                                    }
                                    type="submit"
                                  >
                                    <FaWandMagicSparkles
                                      style={{
                                        fontSize: "16px",
                                        display: "block",
                                      }}
                                    />
                                  </button> */}
                    </div>
                  </FormGroup>
                </FormWrapper>
              </form>
              {/* {this.state.suggestionsList && (
                <ul className="suggestionBox">
                  {this.state.suggestionsList &&
                    this.state.suggestionsList.map((data, index) => {
                      return (
                        data &&
                        data.content && <li key={index}>{data.content}</li>
                      );
                    })}
                </ul>
              )} */}
            </div>
          ) : (
            ""
          )}
        </InsightRow>
      </DataWrapperClass>
    );
  }
}
const stateToProps = (state) => ({
  callInfo: globalStateSelector.getInfo(state),
  callTeam: globalStateSelector.getDynamic(state, { key: "callTeam" }),
  customerNumber: globalStateSelector.getCallCustomerNumber(state),
  teamList: globalStateSelector.getTeamList(state),
  team: globalStateSelector.getSelectedTeam(state),
  email: smsemailSelector.getEmail(state),
  sms: smsemailSelector.getSms(state),
  messageList: chatSelector.getChatDynamic(state, "messageList"),
  // activeTab: smsemailSelector.getActiveTab(state)
  callTranscript: globalStateSelector.getTranscriptionSet(state),
  callTagList: globalStateSelector.getDynamic(state, { key: "callTagList" }),
  agentAssist: globalStateSelector.getAgentAssist(state),
});
const dispatchToProps = (dispatch) => ({
  setSms: (data) => {
    dispatch(smsemailAction.setSms({ data }));
  },
  setEmail: (data) => {
    dispatch(smsemailAction.setEmail({ data }));
  },
  setAgentAssist: (data) => {
    dispatch(callAction.setAgentAssist({ data }));
  },
  // setActiveTab: data => {
  //   dispatch(smsemailAction.setActiveTab({data}))
  // }
});
export default connect(stateToProps, dispatchToProps)(ContactInfoSmartAgent);



// WEBPACK FOOTER //
// src/modules/theme/theme1/common/components/ContactInfoSmartAgent.js